import { useQuery } from '@tanstack/react-query';

import { apiInstance } from '../services/service-trips-api/service-trips-api';
import { AddressSearchResponseItem } from '../services/service-trips-api/types';
import { QueryKeys } from './types';

export * from './passenger';
export * from './user';
export * from './types';
export * from './trips';
export * from './agreement-partners';
export * from './notification';
export * from './absence';
export * from './schedule-types';
export * from './schedule-actions';
export * from './institutions';
export * from './passenger-pending-review';

export const useGetAddressWithHouseNoQuery = (
  houseNo: number,
  partialAddress: Partial<AddressSearchResponseItem>
) =>
  useQuery({
    queryKey: [QueryKeys.ListPassengers, houseNo, partialAddress],
    queryFn: async () => {
      const data = await apiInstance.addressSearch({
        pOIName: partialAddress?.poiName,
        streetName: partialAddress?.streetName,
        houseLetter: partialAddress?.houseLetter,
        houseNo: String(houseNo),
        city: partialAddress?.city,
        regionName: ['Alleregioner'],
      });
      return data?.[0];
    },
  });
